import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';
import useSessionContext from '../../../data/queryHooks/useSessionContext';
import { GetClinicalPELResourcesBySiteSectionFn } from '../../../data/apiCalls';
import { PAGE_ROUTES } from '../../../scripts/routes';

const TierLevel = ({ tierLevel, specialtyDescription, hasDefaultLocation }) => {
	const shouldShowTier = ['PT/OT', 'Chiropractic', 'Acupuncture'];
	const { drFedId, providerId } = useSessionContext();
	const { data } = useQuery(
		['ClinicalPELResourcesBySiteSection', drFedId],
		() =>
			GetClinicalPELResourcesBySiteSectionFn(
				drFedId,
				providerId,
				'Tier Level (only displays in header)'
			),
		{ staleTime: Infinity }
	);

	const url = data?.data?.data?.result[0]?.url || PAGE_ROUTES.pageNotFound;

	return (
		<div>
			{specialtyDescription &&
			shouldShowTier.includes(specialtyDescription) ? (
				<Typography variant='subtitle2'>
					{`${specialtyDescription}`}
					{hasDefaultLocation && (
						<>
							{` - `}

							<Link
								variant='subtitle2'
								href={url}
								target='_blank'
								rel='noreferrer'
							>
								Tier Level: {tierLevel}
							</Link>
						</>
					)}
				</Typography>
			) : (
				<Typography variant='subtitle2'>
					{`${specialtyDescription}`}
				</Typography>
			)}
		</div>
	);
};

TierLevel.propTypes = {
	specialtyDescription: PropTypes.string.isRequired,
	tierLevel: PropTypes.string.isRequired,
	hasDefaultLocation: PropTypes.bool.isRequired,
};

export default TierLevel;
